/**
 * Thin Product Utilization controller. Forwards UI calls to the service
 * unchanged. Per the project's hexagonal rules: controllers are thin; all
 * business logic lives in the service.
 *
 * Type lives in `src/hexagon/adapters/types/productUtilizationController.d.ts`.
 */

export const ProductUtilizationControllerFactory = ({
  productUtilizationService,
}: {
  productUtilizationService: IProductUtilizationService;
}): IProductUtilizationController => ({
  getNeoConversations: productUtilizationService.getNeoConversations,
  getNeoConversation: productUtilizationService.getNeoConversation,
  filterNeoConversations: productUtilizationService.filterNeoConversations,
});
